export const surgeries = [
  {
    id: 1,
    name: { EN: 'Face Lifting', ES: 'Lifting Facial', PT: 'Lifting Facial' },
    content: {
      EN: `As we age, facial changes due to skin laxity, fat atrophy, muscle action, and bone resorption lead to a tired appearance.
Facelift surgery (rhytidectomy) addresses these by repositioning internal structures and skin, restoring a youthful look.

Surgery: Typically performed under local anesthesia with sedation. Patients usually stay overnight.
Post-Operative Care:
First Week: Stitches removed from day 7.
After 20 Days: Resume daily activities.
After 60 Days: Upper body physical activities allowed.`,
      ES: `A medida que envejecemos, los cambios faciales debido a la flacidez de la piel y la pérdida de grasa conducen a una apariencia cansada.
La cirugía de lifting facial (ritidectomía) aborda esto reposicionando las estructuras internas para restaurar un aspecto juvenil.

Cirugía: Típicamente bajo anestesia local con sedación. Hospitalización de una noche.
Cuidados Postoperatorios:
Primera Semana: Retiro de puntos desde el día 7.
Después de 20 Días: Retomar actividades diarias normales.
Después de 60 Días: Actividad física del tren superior permitida.`,
      PT: `À medida que envelhecemos, as alterações faciais devido à flacidez e atrofia da pele levam a uma aparência cansada.
A cirurgia de lifting facial (ritidectomia) resolve isso reposicionando as estruturas internas e a pele para uma aparência jovem.

Cirurgia: Realizada sob anestesia local com sedação. Geralmente, uma noite no hospital.
Cuidados Pós-Operatórios:
Primeira Semana: Retirada de pontos a partir do 7º dia.
Após 20 Dias: Retomar atividades diárias.
Após 60 Dias: Atividades físicas da parte superior do corpo.`
    },
    image: './surgeriesfolder/Face_Lifting.webp'
  },
  {
    id: 2,
    name: { EN: 'Rhinoplasty', ES: 'Rinoplastia', PT: 'Rinoplastia' },
    content: {
      EN: `Rhinoplasty, commonly referred to as a "nose job," is a surgical procedure designed to improve the shape, size, or functionality of the nose.

Surgery: Usually completed within 1-3 hours.
Post-Operative Care:
First Week: Splints and stitches are removed.
After 14 Days: Most visible swelling resolves.
After 30 Days: Avoid strenuous activities.
After 6 Months: Final results are fully apparent.`,
      ES: `La Rinoplastia es un procedimiento quirúrgico diseñado para mejorar la forma, el tamaño o la funcionalidad de la nariz.

Cirugía: Por lo general toma de 1 a 3 horas.
Cuidados Postoperatorios:
Primera Semana: Se retiran férulas y puntos.
Después de 14 Días: La inflamación visible disminuye.
Después de 30 Días: Evitar actividades extenuantes.
Después de 6 Meses: Los resultados finales son muy evidentes.`,
      PT: `A Rinoplastia é um procedimento cirúrgico desenvolvido para melhorar a forma, tamanho ou funcionalidade do nariz.

Cirurgia: Geralmente concluída entre 1-3 horas.
Cuidados Pós-Operatórios:
Primeira Semana: Talas e pontos são retirados.
Após 14 Dias: O inchaço mais visível desaparece.
Após 30 Dias: Evite atividades extenuantes.
Após 6 Meses: Os resultados finais ficam completos.`
    },
    image: './surgeriesfolder/Rhinoplasty.webp'
  },
  {
    id: 3,
    name: { EN: 'Blepharoplasty', ES: 'Blefaroplastia', PT: 'Blefaroplastia' },
    content: {
      EN: `Blepharoplasty, or eyelid surgery, is a procedure designed to rejuvenate the appearance of the eyes by addressing sagging upper eyelids or under-eye bags.

Surgery: Performed under local anesthesia with sedation. Lasts 1-2 hours.
Post-Operative Care:
First Week: Swelling and bruising reduce significantly.
After 10-14 Days: Resume social and professional activities.
After 3 Months: Scars become less noticeable.`,
      ES: `La Blefaroplastia o cirugía de párpados, rejuvenece la apariencia de los ojos al tratar los párpados caídos o las bolsas bajo los ojos.

Cirugía: Bajo anestesia local con sedación. Dura 1-2 horas.
Cuidados Postoperatorios:
Primera Semana: La hinchazón disminuye.
Después de 10-14 Días: Retomar actividades sociales.
Después de 3 Meses: Las cicatrices son menos perceptibles.`,
      PT: `Blefaroplastia, ou cirurgia das pálpebras, rejuvenesce a aparência dos olhos tratando as pálpebras caídas ou bolsas.

Cirurgia: Sob anestesia local com sedação. Dura 1-2 horas.
Cuidados Pós-Operatórios:
Primeira Semana: Inchaço e hematomas diminuem.
Após 10-14 Dias: Retome as atividades sociais normais.
Após 3 Meses: Cicatrizes tornam-se menos visíveis.`
    },
    image: './surgeriesfolder/Blepharoplasty.webp'
  },
  {
    id: 4,
    name: { EN: 'Otoplasty', ES: 'Otoplastia', PT: 'Otoplastia' },
    content: {
      EN: `Otoplasty, commonly known as ear surgery, is a cosmetic procedure that reshapes or repositions the ears to achieve a more balanced appearance.

Surgery: Usually performed under local anesthesia. The surgery takes 1-2 hours.
Post-Operative Care:
First Week: A headband or bandages are worn.
After 10-14 Days: Bandages are removed.
After 3-6 Months: Final results are apparent.`,
      ES: `La Otoplastia (cirugía de orejas), es un procedimiento estético que contornea o reposiciona las orejas para lograr una apariencia equilibrada.

Cirugía: Anestesia local y dura 1-2 horas.
Cuidados Postoperatorios:
Primera Semana: Uso de banda o vendajes continuos.
Después de 10-14 Días: Retiro de vendajes.
Después de 3-6 Meses: Resultados finales evidentes.`,
      PT: `A Otoplastia, conhecida como cirurgia de orelhas, reposiciona as orelhas para obter uma aparência mais equilibrada.

Cirurgia: Geralmente sob anestesia local. Dura 1-2 horas.
Cuidados Pós-Operatórios:
Primeira Semana: Uso de bandagem cobrindo as orelhas.
Após 10-14 Dias: As bandagens são removidas.
Após 3-6 Meses: Resultados finais evidentes.`
    },
    image: './surgeriesfolder/Otoplasty.webp'
  },
  {
    id: 5,
    name: { EN: 'Mentoplasty', ES: 'Mentoplastia', PT: 'Mentoplastia' },
    content: {
      EN: `Mentoplasty, also known as chin surgery, is designed to enhance the contours of the chin, improving facial balance and harmony.

Surgery: Performed under local anesthesia with sedation. Takes 1-2 hours.
Post-Operative Care:
First Week: Swelling and bruising are common. Stitches are removed.
After 14 Days: Return to social activities.
After 3-6 Months: Final results become apparent.`,
      ES: `La Mentoplastia o cirugía de mentón, mejora los contornos del mentón y el equilibrio facial general.

Cirugía: Anestesia local con sedación. Dura 1-2 horas.
Cuidados Postoperatorios:
Primera Semana: Hinchazón es normal. Cierre de puntos.
Después de 14 Días: Retorno a las obligaciones sociales.
Después de 3-6 Meses: Recuperación total del perfil.`,
      PT: `Mentoplastia, u cirurgia do queixo, melhora os contornos do queixo, equilibrando a harmonia facial.

Cirurgia: Anestesia local com sedação. Dura 1-2 horas.
Cuidados Pós-Operatórios:
Primeira Semana: Inchaço é comum. Os pontos são removidos.
Após 14 Dias: Retorno a atividades sociais.
Após 3-6 Meses: Recuperação final evidente.`
    },
    image: '../surgeriesfolder/Mentoplasty.webp'
  },
  {
    id: 6,
    name: { EN: 'Breast Augmentation', ES: 'Aumento de Senos', PT: 'Aumento de Mama' },
    content: {
      EN: `Breast augmentation enhances the size, shape, and symmetry of the breasts using implants or fat transfer.

Surgery: General anesthesia. Lasts 1-2 hours.
Post-Operative Care:
First Week: A surgical bra is worn. Most patients can resume light activities.
After 4-6 Weeks: Exercise can be gradually resumed.
After 3-6 Months: Implants settle completely.`,
      ES: `El aumento de mama realza el tamaño, forma y simetría de los senos utilizando implantes o transferencia de grasa.

Cirugía: Anestesia general. Dura de 1 a 2 horas.
Cuidados Postoperatorios:
Primera Semana: Se usa un sostén quirúrgico postoperatorio.
Después de 4-6 Semanas: Ejercicio y esfuerzo leve se pueden retomar.
Después de 3-6 Meses: Los implantes se asientan por completo.`,
      PT: `Aumento de mama aumenta o tamanho e simetria dos seios usando implantes ou enxerto de gordura.

Cirurgia: Anestesia geral. Demora 1-2 horas.
Cuidados Pós-Operatórios:
Primeira Semana: Usa-se sutiã cirúrgico.
Após 4-6 Semanas: Os treinos podem ser retomados com calma.
Após 3-6 Meses: Os implantes assumem a forma final.`
    },
    image: './surgeriesfolder/Breast_Prosthesis.webp'
  },
  {
    id: 7,
    name: { EN: 'Breast Reduction', ES: 'Reducción Mamaria', PT: 'Redução de Mama' },
    content: {
      EN: `Breast reduction reduces the size and weight of overly large breasts, alleviating physical discomfort.

Surgery: General anesthesia. Takes 2-4 hours. Overnight stay common.
Post-Operative Care:
First Week: Patients wear a surgical bra. Stitches might be removed.
After 4-6 Weeks: Physical activities resumed.
After 3-6 Months: Scars fade, results look natural.`,
      ES: `La reducción mamaria reduce el tamaño y peso de los senos, aliviando incomodidad física como dolor de espalda.

Cirugía: Anestesia general. Toma de 2 a 4 horas.
Cuidados Postoperatorios:
Primera Semana: Uso de sostén médico especial.
Después de 4-6 Semanas: Retoma del ejercicio.
Después de 3-6 Meses: Las cicatrices se vuelven más finas.`,
      PT: `A redução de mama diminui o tamanho e o peso dos seios grandes, oferecendo conforto físico.

Cirurgia: Anestesia geral. De 2 a 4 horas.
Cuidados Pós-Operatórios:
Primeira Semana: Uso de sutiã cirúrgico contínuo.
Após 4-6 Semanas: Atividades físicas permitidas.
Após 3-6 Meses: As cicatrizes começam a clarear.`
    },
    image: './surgeriesfolder/Breast_Reduction.webp'
  },
  {
    id: 8,
    name: { EN: 'Breast Lift', ES: 'Levantamiento de Senos', PT: 'Lifting de Mama (Mastopexia)' },
    content: {
      EN: `A breast lift (mastopexy) reshapes sagging breasts, restoring a youthful and firmer appearance.

Surgery: General anesthesia. Takes 2-3 hours.
Post-Operative Care:
First Week: Mild swelling and discomfort. Surgical bra needed.
After 4-6 Weeks: Exercise gradually resumed. Avoid heavy lifting.
After 3-6 Months: Scars blend with natural contours.`,
      ES: `El levantamiento de senos (mastopexia) da forma a los senos caídos, restaurando un aspecto firme y juvenil.

Cirugía: Anestesia general. Toma de 2 a 3 horas.
Cuidados Postoperatorios:
Primera Semana: Sostén médico permanente.
Después de 4-6 Semanas: Ejercicio sutil permitido.
Después de 3-6 Meses: Resultados definidos y naturales.`,
      PT: `A mastopexia (lifting de mamas) levanta e dá forma aos seios flácidos, restituindo um aspeto jovem.

Cirurgia: Anestesia geral. Demora 2-3 horas.
Cuidados Pós-Operatórios:
Primeira Semana: Sutiã médico. Desconforto leve.
Após 4-6 Semanas: Exercícios regressam de forma moderada.
Após 3-6 Meses: Cicatrizes e inchaço minimizados.`
    },
    image: './surgeriesfolder/Breast_Lift.webp'
  },
  {
    id: 9,
    name: { EN: 'Gynecomastia', ES: 'Ginecomastia', PT: 'Ginecomastia' },
    content: {
      EN: `Gynecomastia surgery removes excess tissue from male breasts to restore a more masculine chest appearance.

Surgery: Local anesthesia with sedation. Takes 1-2 hours.
Post-Operative Care:
First Week: Compression garment worn to support healing.
After 4-6 Weeks: Upper-body workouts can resume.
After 3-6 Months: Scars fade over time.`,
      ES: `La cirugía de ginecomastia elimina el exceso de tejido en los senos masculinos para un tórax más varonil y definido.

Cirugía: Anestesia local con sedación. Toma 1-2 horas.
Cuidados Postoperatorios:
Primera Semana: Ropa de compresión estricta.
Después de 4-6 Semanas: Entrenamiento de tren superior.
Después de 3-6 Meses: Los resultados finales son muy buenos y ocultos.`,
      PT: `A ginecomastia elimina o excesso de tecido nas mamas masculinas garantindo um tronco firme.

Cirurgia: Anestesia local com sedação. 1 a 2 horas.
Cuidados Pós-Operatórios:
Primeira Semana: Malha de compressão médica.
Após 4-6 Semanas: Exercício e peso liberados.
Após 3-6 Meses: Os contornos assentam na perfeição.`
    },
    image: './surgeriesfolder/Gynecomastia.webp'
  },
  {
    id: 10,
    name: { EN: 'Mommy Makeover', ES: 'Mommy Makeover', PT: 'Mommy Makeover' },
    content: {
      EN: `A Mommy Makeover is a personalized combination of procedures designed to restore a woman’s body after pregnancy. Tummy Tuck, Breast Surgery, and Liposuction are the most common.

Surgery: General anesthesia. Takes 4-6 hours.
Post-Operative Care:
First Week: Rest is crucial. Compression garments worn.
After 4-6 Weeks: Avoid heavy lifting. Resume light physical activities.
After 3-6 Months: Firm, youthful appearance restored.`,
      ES: `El Mommy Makeover es una combinación de procedimientos quirúrgicos para restaurar la figura tras los embarazos (Abdominoplastia, Cirugía de senos y Liposucción).

Cirugía: Anestesia general. Toma de 4 a 6 horas.
Cuidados Postoperatorios:
Primera Semana: Reposo absoluto. Faja compresiva constante.
Después de 4-6 Semanas: Caminatas y esfuerzos mínimos.
Después de 3-6 Meses: Contorno firme y definido.`,
      PT: `Mommy Makeover é a combinação de cirurgias feitas para reverter os efeitos da gravidez (Abdominoplastia, Mamas, Lipoaspiração).

Cirurgia: Anestesia geral. Até 6 horas de duração.
Cuidados Pós-Operatórios:
Primeira Semana: Repouso extremo. Cintas de compressão.
Após 4-6 Semanas: Caminhadas fáceis.
Após 3-6 Meses: Forma restaurada com enorme sucesso.`
    },
    image: './surgeriesfolder/Mommy_Makeover.webp'
  },
  {
    id: 11,
    name: { EN: 'Abdominoplasty', ES: 'Abdominoplastia', PT: 'Abdominoplastia' },
    content: {
      EN: `Abdominoplasty (tummy tuck) removes excess skin and fat and tightens weakened abdominal muscles.

Surgery: General anesthesia. Lasts 2-4 hours.
Post-Operative Care:
First Week: Drains may be placed. Compression garment is vital.
After 4-6 Weeks: Return to work and light active life.
After 3-6 Months: Flatter, more toned abdominal profile.`,
      ES: `La abdominoplastia elimina el exceso de piel flácida y grasa, al tiempo que tensa los músculos abdominales debilitados.

Cirugía: Anestesia general. Toma 2-4 horas.
Cuidados Postoperatorios:
Primera Semana: Pueden llevarse drenajes. Faja médica permanente.
Después de 4-6 Semanas: Vida normal pero sin esfuerzo extremo.
Después de 3-6 Meses: Vientre más liso y contorneado.`,
      PT: `A abdominoplastia retira pele flácida e ajusta a musculatura do abdômen devolvendo a tensão original.

Cirurgia: Anestesia geral. 2-4 horas.
Cuidados Pós-Operatórios:
Primeira Semana: Uso de drenos. Cintas especiais obrigatórias.
Após 4-6 Semanas: Vida social mais normal, exercícios leves.
Após 3-6 Meses: Abdômen firme e de ótima aparência.`
    },
    image: './surgeriesfolder/Abdominoplasty.webp'
  },
  {
    id: 12,
    name: { EN: 'Liposuction', ES: 'Liposucción', PT: 'Lipoaspiração' },
    content: {
      EN: `Liposuction is a minimally invasive surgery to remove stubborn fat deposits that resist diet and exercise.

Surgery: Local or general anesthesia. Lasts 1-3 hours.
Post-Operative Care:
First Week: Compression garment worn to reduce swelling.
After 4-6 Weeks: Exercise can gradually resume.
After 3-6 Months: Smoother and more defined silhouette.`,
      ES: `La liposucción elimina depósitos de grasa difíciles de reducir con dietas, moldeando la silueta.

Cirugía: Local o General. Toma 1-3 horas.
Cuidados Postoperatorios:
Primera Semana: Uso ininterrumpido de fajas o tablas.
Después de 4-6 Semanas: Ejercicio cardio ligero.
Después de 3-6 Meses: Figura delgada y esculpida.`,
      PT: `A lipoaspiração remove gorduras teimosas que nem dieta nem foco conseguem eliminar.

Cirurgia: Local ou geral (1 a 3 horas).
Cuidados Pós-Operatórios:
Primeira Semana: Malha de compressão 24/7 para desinchar.
Após 4-6 Semanas: Esforço físico diário autorizado se moderado.
Após 3-6 Meses: O corpo estará elegante e visivelmente modelado.`
    },
    image: './surgeriesfolder/Liposuction.webp'
  },
  {
    id: 13,
    name: { EN: 'Brachioplasty and Thigh Lifting', ES: 'Lifting de Brazos y Muslos', PT: 'Lifting de Braços e Coxas' },
    content: {
      EN: `Brachioplasty (Arm Lift) reshapes the upper arms by removing excess skin and fat due to weight loss or aging.

Surgery: General anesthesia. Lasts 2-3 hours.
Post-Operative Care:
First Week: Compression garment to support healing.
After 4-6 Weeks: Upper-body exercises can gradually resume.
After 3-6 Months: Scars mature and blend in.`,
      ES: `El lifting de brazos y muslos corrige la flacidez de la piel y grasa descolgada tras pérdidas masivas de peso o por edad.

Cirugía: Anestesia general. Toma 2-3 horas.
Cuidados Postoperatorios:
Primera Semana: Control de drenajes y ropa compresiva firme.
Después de 4-6 Semanas: Los brazos y muslos recuperan movilidad plena.
Después de 3-6 Meses: La piel cicatriza ocultando marcas en los surcos corporales.`,
      PT: `O lifting (Braquioplastia) ajusta a pele dos braços e pernas caídos.

Cirurgia: Anestesia geral (2 a 3 horas).
Cuidados Pós-Operatórios:
Primeira Semana: Compressão, repouso e sem peso nos membros.
Após 4-6 Semanas: Amplitude dos membros quase a 100%.
Após 3-6 Meses: Toda a operação estabiliza criando contornos invejáveis.`
    },
    image: './surgeriesfolder/Brachioplasty_and_Thigh_Lifting.webp'
  },
  {
    id: 14,
    name: { EN: 'Intimate Surgery', ES: 'Cirugía Intima', PT: 'Cirurgia Íntima' },
    content: {
      EN: `Intimate surgery focuses on enhancing the aesthetics, comfort, and functionality of the genital area (Labiaplasty, Vaginoplasty).

Surgery: Local or general anesthesia, 1-3 hours.
Post-Operative Care:
First Week: Swelling and mild discomfort are common.
After 4-6 Weeks: Full recovery, with resumption of physical and sexual activities.`,
      ES: `La cirugía íntima mejora la estética, la comodidad y la funcionalidad de la región genital femenina (Labioplastia, etc).

Cirugía: Local o General, 1-3 horas.
Cuidados Postoperatorios:
Primera Semana: Molestias, usar ropa suave y holgada.
Después de 4-6 Semanas: Recuperación plena de tejido muscular y vida sexual de nuevo permitida.`,
      PT: `Cirurgias íntimas trazem maior confiança nas regiões genitais preenchidas, corrigidas ou unidas (Labioplastia).

Cirurgia: Local ou anestesia moderada, 1-3 horas.
Cuidados Pós-Operatórios:
Primeira Semana: Máximo de resguardo possível, banhos mornos e calmaria.
Após 4-6 Semanas: Vida restabelecida a 100%.`
    },
    image: './surgeriesfolder/Intimate_Surgery.webp'
  },
  {
    id: 19,
    name: { EN: 'Bichectomy', ES: 'Bichectomía', PT: 'Bichectomia' },
    content: {
      EN: `Bichectomy enhances facial contours by removing excess fat from the buccal fat pads in the cheeks.

Surgery: Local anesthesia. Lasts 30-60 minutes.
Post-Operative Care:
First Week: Mild swelling. Soft diet recommended.
After 2 Weeks: Swelling subsides significantly.
After 3-6 Months: Slimmer, more defined cheeks.`,
      ES: `La Bichectomía mejora y afina los contornos faciales eliminando la grasa de las bolsas de Bichat y marcando pómulos.

Cirugía: Anestesia local en zona maxilar (30-60 mins).
Cuidados Postoperatorios:
Primera Semana: Hielo y dieta blanda o líquida.
Después de 2 Semanas: Gran parte del trauma interno baja.
Después de 3-6 Meses: Perfil totalmente adelgazado.`,
      PT: `A remoção da bola de Bichat (Bichectomia) aprimora a silhueta da face realçando os ângulos do rosto.

Cirurgia: Anestesia local com tempo super curto de 30 minutos.
Cuidados Pós-Operatórios:
Primeira Semana: Dieta suave, mastigação delicada e gelo.
Após 2 Semanas: Desincha de vez.
Após 3-6 Meses: Traços desenhados e esguios.`
    },
    image: './surgeriesfolder/Bichectomy.webp'
  },
  {
    id: 20,
    name: { EN: 'Scar Correction', ES: 'Corrección de Cicatrices', PT: 'Correção de Cicatrizes' },
    content: {
      EN: `Scar revision surgery improves the appearance of scars caused by injuries, surgeries, or conditions.

Surgery: Local or general anesthesia.
Post-Operative Care:
First Week: Swelling and redness. Keep clean.
After 4-6 Weeks: The scar begins to fade and flatten.
After 1 Year: Final results are visible.`,
      ES: `Revisión y cirugía para mejorar y ocultar el aspecto de cicatrices post-accidente o post-cirugía general (Queloides).

Cirugía: Local.
Cuidados Postoperatorios:
Primera Semana: Cuidar mucho de la polución de la herida nueva.
Después de 4-6 Semanas: La nueva cicatriz empieza el proceso de acoplamiento al cuerpo plano.
Después de 1 Año: Queda de la forma esperada invisible o estéticamente fina.`,
      PT: `Para atenuar cicatrizes (como as queloides) e integrá-las melhor à elasticidade e visual da tez.

Cirurgia: Correção local.
Cuidados Pós-Operatórios:
Primeira Semana: Evitar sujeiras na cicatriz renovada.
Após 4-6 Semanas: Textura e coloração mudam, alisamento ocorre lentamente.
Após 1 Ano: Melhoria notável completando o ciclo.`
    },
    image: './surgeriesfolder/Scar_Correction.webp'
  },
  {
    id: 21,
    name: { EN: 'Reconstructive Plastic Surgery', ES: 'Cirugía Plástica Reconstructiva', PT: 'Cirurgia Plástica Reparadora' },
    content: {
      EN: `Focuses on restoring form and function to areas of the body affected by trauma, congenital conditions, or disease.

Surgery: General or local anesthesia.
Post-Operative Care:
First Week: Swelling and discomfort are managed.
After 4-6 Weeks: Normal activities gradually resume.
After 1 Year: Final results as tissues heal completely.`,
      ES: `La cirugía reconstructiva busca restaurar la funcionalidad y la forma después de un accidente o trauma (reconstrucción por cáncer, paladar hendido).

Cirugía: Dependiente, se asume general reconstructiva de tiempos mixtos.
Cuidados Postoperatorios:
Primera Semana: Cuidado riguroso post-quirófano de clínica.
Después de 4-6 Semanas: Se reinicia algo de capacidad en el cuerpo.
Después de 1 Año: Los injertos y/o colgajos completan su regeneración.`,
      PT: `Reparadora procura reconstruir após doenças necróticas/cancerosas e traumas complexos do momento da vida.

Cirurgia: Intensa. Requer exames contínuos.
Cuidados Pós-Operatórios:
Primeira Semana: Vigilância médica exigente perante feridas intensas.
Após 4-6 Semanas: Começam exercícios de reconexão do sistema da carne do novo espaço.
Após 1 Ano: Paciente em pleno restabelecimento biológico total da simetria visual alcançável.`
    },
    image: './surgeriesfolder/Reconstructive_Plastic_Surgery.webp'
  },
  {
    id: 16,
    name: { EN: 'Skin Tumors', ES: 'Tumores Cutáneos', PT: 'Tumores Cutâneos' },
    content: {
      EN: `Skin tumors are lesions that can be benign or malignant. Timely treatment ensures safety and optimal aesthetics.

Surgery: Local anesthesia.
Post-Operative Care:
First Week: Keep the area clean and protected.
After 2 Weeks: Stitches removed. Wound begins to heal.
After 3-6 Months: Scar matures and fades.`,
      ES: `Los tumores cutáneos son lesiones malignas (cánceres de piel, melanoma) o benignos. Extirpación temprana salva vidas.

Cirugía: Local ambulatoria si es detección precoz.
Cuidados Postoperatorios:
Primera Semana: Profilácticos básicos sobre biopsia o margen libre.
Después de 2 Semanas: Retiro de puntos no reabsorbibles.
Después de 3-6 Meses: Prevención permanente sobre esa huella y uso bloqueador extremo.`,
      PT: `Remoção de nevos/carcinomas visando tanto as garantias oncológicas puras como salvar a estética perfeita sem buracos inestéticos da epiderme.

Cirurgia: Recorte local limpo curativo.
Cuidados Pós-Operatórios:
Primeira Semana: Lavagem restrita de área e pomadas de cicatrização.
Após 2 Semanas: Fios fora de ação definitiva.
Após 3-6 Meses: Sem vestígios aparentes do local extraído em alta proporção.`
    },
    image: './surgeriesfolder/Tumores_Cutaneos.webp'
  }
];